import {skeletonGet} from "./skeleton/skeletonGet";

const internalEndpoint = 'fx'

export const GetFixturesCall = (): Promise<any> => {
    return skeletonGet('fixture', internalEndpoint);
};


